module.exports = __webpack_public_path__ + "img/tip.87f505e4.png";